import { MainContentArea, ContentHeader, DesignTokens } from "melco-ui";
import { useTranslation } from "react-i18next";
import DownloadsContainer from "../../components/donwloads/DownloadsContainer";
import styled from "styled-components";
import { useAppSettings } from "../../hooks/appsettings/useAppSettings";

export const Downloads: React.FC = () => {
    const { t } = useTranslation();
    const { spacings } = DesignTokens;
    const { isLoading, appSettingsResponse } = useAppSettings();
    const ContentWrapper = styled.div`
    padding-left: ${spacings.xlarge}px;
`
    if (isLoading) {
        return null;
    }

    return (
        <MainContentArea
            header={
                <ContentHeader
                    title={t("main_menu.downloads")}

                />

            }
        >
            <ContentWrapper >
                {
                    !isLoading && <DownloadsContainer
                        appSettingsResponse={appSettingsResponse}

                    />
                }

            </ContentWrapper>
        </MainContentArea>
    );
};
